module.exports = __webpack_public_path__ + "img/jiuye.164334fd.png";